'use client';

export default function ArSettingsPage() {
  return <div>ArSettingsPage</div>;
}
